import { all } from 'redux-saga/effects';

import {
  getVaultRequestByIdWatcher,
  getHyperlinkByIdWatcher,
  vaultCardWatcher,
} from './vaultingScreenSaga';

import {
  getBuyerContactListWatcher,
  getVaultRequestListWatcher,
  deleteVaultRequestWatcher,
  deleteBuyerContactWatcher,
  updateVaultRequestWatcher,
  addNewBuyerContactWatcher,
  updateBuyerContactWatcher,
  addNewVaultRequestWatcher,
  getFilteredBuyerRecordsWatcher,
  getFilteredSupplierRecordsWatcher,
  addNewHyperLinkWatcher,
  getSupplierSecretsWatcher,
} from './contactsAndVaultingRequestsSaga';
import { getUserActListWatcher } from './userActivitySaga';
import { getVaultActListWatcher } from './vaultingActivitySaga';

export default function* rootSaga() {
  yield all([
    getVaultRequestByIdWatcher(),
    getHyperlinkByIdWatcher(),
    vaultCardWatcher(),
    getBuyerContactListWatcher(),
    getVaultRequestListWatcher(),
    deleteVaultRequestWatcher(),
    deleteBuyerContactWatcher(),
    updateVaultRequestWatcher(),
    addNewBuyerContactWatcher(),
    addNewVaultRequestWatcher(),
    updateBuyerContactWatcher(),
    getFilteredBuyerRecordsWatcher(),
    getFilteredSupplierRecordsWatcher(),
    addNewHyperLinkWatcher(),
    getUserActListWatcher(),
    getVaultActListWatcher(),
    getSupplierSecretsWatcher(),
  ]);
}
